import type { TranscriptEntry, StdoutLineParser } from "@ligament/adapter-utils";

/**
 * Parse Bedrock adapter stdout lines into transcript entries for the UI.
 */
export const parseBedrockStdout: StdoutLineParser = (line: string, ts: string): TranscriptEntry[] => {
  const trimmed = line.trim();
  if (!trimmed) return [];

  // Tool call output
  if (trimmed.startsWith("[tool_call]")) {
    const content = trimmed.replace("[tool_call] ", "");
    const colonIdx = content.indexOf(":");
    if (colonIdx > 0) {
      const name = content.substring(0, colonIdx).trim();
      const inputStr = content.substring(colonIdx + 1).trim();
      try {
        const input = JSON.parse(inputStr);
        return [{ kind: "tool_call", ts, name, input }];
      } catch {
        return [{ kind: "tool_call", ts, name, input: inputStr }];
      }
    }
  }

  // Tool result output
  if (trimmed.startsWith("[tool_result]")) {
    const content = trimmed.replace("[tool_result] ", "");
    return [{ kind: "tool_result", ts, toolUseId: "", content, isError: false }];
  }

  // Bedrock metadata
  if (trimmed.startsWith("[bedrock]")) {
    return [{ kind: "system", ts, text: trimmed }];
  }

  // Regular assistant output
  return [{ kind: "assistant", ts, text: trimmed }];
};
